import { defineComponent } from "vue";
import SdkModalNote from "@/components/sdk-modal/sdk-modal-note.vue";
import { SdkTableColumn, SdkTableColumnNote } from "@/interfaces/sdk-dictionary";
import { EventBus } from "@/utils/event-bus";

export default defineComponent({
  name: "pg-modal",
  components: { SdkModalNote },
  data() {
    return {
      dialogTableVisible: false,
      title: "",
      createdNotes: "",
      deleteNotes: "",
      owner: "",
      tableName: "",
      column: {
        id: 0,
        name: "",
        type: "",
        typeKey: "",
        length: 0,
        precision: 0,
        scale: 0,
        nullable: "",
        defaultValue: "",
        comment: "",
        constraints: [
          {
            id: 0,
            name: "",
            type: "",
            searchCondition: "",
            ownerRef: null,
            constraintNameRef: null,
          },
        ],
        notes: [
          {
            id: 0,
            owner: "",
            tableName: "",
            columnName: "",
            userName: "",
            note: "",
            lastChange: "",
            versionId: 0,
          },
        ],
      } as SdkTableColumn,
    };
  },
  methods: {
    openModal(parameters: any) {
      this.switchModal(parameters.openModal);
      this.column = parameters.column;
      this.column.notes.sort((a: SdkTableColumnNote, b: SdkTableColumnNote) => {
        const aAux = new Date(a.lastChange ? new Date(a.lastChange).getTime() : "").getTime();
        const bAux = new Date(b.lastChange ? b.lastChange : "").getTime();
        return aAux - bAux;
      });
      this.owner = parameters.owner;
      this.tableName = parameters.tableName;
      this.createdNotes = parameters.createdNotes;
      this.deleteNotes = parameters.deleteNotes;
    },
    switchModal(switcher?: boolean) {
      if (switcher !== undefined) {
        this.dialogTableVisible = switcher;
      } else {
        this.dialogTableVisible = !this.dialogTableVisible;
      }
    },
    createNote() {
      const newNote = {
        owner: this.owner,
        tableName: this.tableName,
        columnName: this.column.name,
        userName: "",
        note: "",
        lastChange: new Date().toISOString(),
        versionId: 0,
      };
      this.column.notes.push(newNote);
      EventBus.$on("on-note-ready", () => {
        this.emitEditMode(newNote);
      });
    },
    emitEditMode(newNote: SdkTableColumnNote) {
      EventBus.$emit("edit-note", newNote);
      EventBus.$off("on-note-ready");
    },
    addChildNote(parameter: any) {
      this.removeChildNote(parameter.placeholder);
      this.column.notes.push(parameter.note);
    },
    removeChildNote(note: SdkTableColumnNote) {
      this.column.notes.splice(this.column.notes.indexOf(note), 1);
    },
  },
  mounted() {
    this.title = this.$tc("modal.title");
    EventBus.$on("open-modal", this.openModal);
    EventBus.$on("remove-child-note", this.removeChildNote);
    EventBus.$on("new-note-child", this.addChildNote);
  },
  beforeDestroy() {
    EventBus.$off("open-modal");
    EventBus.$off("remove-child-note");
    EventBus.$off("new-note-child");
  },
});
